export enum FieldLayoutDefaultType {
  Display = 1,
  Coding = 2
}
